import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import permission from './modules/permission'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    permission
  },
  getters: {
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    menus: state => state.permission.menus,
    routesReady: state => state.permission.routesReady
  }
})
